import { RequestInstance } from "../../../utils/request";

export const treeData = new RequestInstance({
  method: "get",
  url: "/v2/department/tree",
});

export const dataList = new RequestInstance({
  method: "get",
  url: "/v2/department/member/page",
});

export const addDepartment = new RequestInstance({
  method: "post",
  url: "/v2/department/add",
});

export const editDepartment = new RequestInstance({
  method: "post",
  url: "/v2/department/update",
});

export const removeDepartment = new RequestInstance({
  method: "post",
  url: "/v2/department/delete",
});

export const removeOutDepartment = new RequestInstance({
  method: "post",
  url: "/v2/department/member/delete",
});

export const notBindData = new RequestInstance({
  method: "get",
  url: "/v2/department/unbinding/member/page",
});

export const hasBindData = new RequestInstance({
  method: "get",
  url: "/v2/department/member/list",
});

export const staffAssignments = new RequestInstance({
  method: "post",
  url: "/v2/department/member/add",
});

export const enterpriseInfo = new RequestInstance({
  method: "get",
  url: "/v2/community/info",
});

export const editEnterprise = new RequestInstance({
  method: "post",
  url: "/v2/community/update",
});
